import {
  AbstractControl, FormGroup, ValidationErrors, ValidatorFn,
} from '@angular/forms';

export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  static sameEmail(fg: FormGroup): ValidationErrors | null {
    const email = fg.get('email');
    const emailRepeat = fg.get('email_repeat');

    if (emailRepeat && email?.value !== emailRepeat?.value) {
      emailRepeat.setErrors({ not_the_same: true });
      return { not_the_same: true };
    } else {
      emailRepeat?.setErrors(null);
    }
    return null;
  }

  static samePassword(fg: FormGroup): ValidationErrors | null {
    const password = fg.get('password');
    const passwordRepeat = fg.get('password_repeat');

    if (password?.value && password?.value !== passwordRepeat?.value) {
      if (passwordRepeat) {
        passwordRepeat.setErrors({ not_matching: true });
      } else {
        return { not_matching: true };
      }
    }
    return null;
  }
}
